import { TOOLS } from '../igroadmap_components/constants';

export const DASHBOARD_BUSINESS_SECTION_NAMES = {
  VISION: 'igbmc_vision',
  EXPERIMENTS: TOOLS.IGBUSINESS,
  CURRENT: 'bmc_current'
};

export const DASHBOARD_TYPES = {
  BUSINESS: 'business',
  CEO: 'ceo',
  PRODUCT: 'product'
};

export const BUSINESS_ROUTES = {
  igbmc_vision: TOOLS.IGBMC,
  igbusiness: TOOLS.IGBUSINESS,
  bmc_current: TOOLS.IG_CURRENT_MODEL
};

export const businessSections = [
  { name: DASHBOARD_BUSINESS_SECTION_NAMES.CURRENT, icon: 'fa fa-map' },
  { name: DASHBOARD_BUSINESS_SECTION_NAMES.EXPERIMENTS, icon: 'fa fa-compass' },
  { name: DASHBOARD_BUSINESS_SECTION_NAMES.VISION, icon: 'fa fa-rocket' }
];

export const BUSINESS_APPS = {
  TASKS: 'tasks',
  BMCS: 'bmc_boards',
  EXPERIMENTS: TOOLS.IGBUSINESS
};
